import { createSelector } from 'reselect';
import { WebInterfaceBaseState } from '../../../common/base/state';
import { List } from 'immutable';
import { IProcess, Process } from '../entities/widgets/model/types/IProcess';

const getProcessDataSelector = (state: WebInterfaceBaseState) =>
	state.modules.dashboard.widgets.processes.data;

const getProcessHasMoreSelector = (state: WebInterfaceBaseState) =>
	state.modules.dashboard.widgets.processes.hasMore;

const getSelectedProcessSelector = (state: WebInterfaceBaseState) =>
	state.modules.dashboard.widgets.processes.selected;

const getLoadingProcessesSelector = (state: WebInterfaceBaseState) =>
	state.modules.dashboard.widgets.processes.loading ||
	state.modules.dashboard.widgets.processDetails.loading;

export const getProcessData = createSelector(
	[getProcessDataSelector],
	(processes: List<Process>): Array<IProcess> =>
		processes?.map(process => process.toJS()).toJS() || []
);

export const getProcessHasMore = createSelector(
	[getProcessHasMoreSelector],
	(hasMore: boolean): boolean => hasMore
);

export const getSelectedProcess = createSelector(
	[getSelectedProcessSelector],
	(selected: Process): IProcess => selected?.toJS()
);

export const getLoadingProcesses = createSelector(
	[getLoadingProcessesSelector],
	(loading: boolean): boolean => loading
);
